import type { SVGProps } from 'react';

const SvgLearningStipend = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M27.09 13.91H16.17v-2.53a10 10 0 0 0 1.11.07A11 11 0 0 0 24 9.14a10.86 10.86 0 0 0 4.23-7.85.75.75 0 0 0-.61-.78 10.82 10.82 0 0 0-8.66 2.12 11 11 0 0 0-3.49 4.63 10.93 10.93 0 0 0-3.5-4.63A10.76 10.76 0 0 0 3.27.51a.75.75 0 0 0-.61.78 10.82 10.82 0 0 0 4.22 7.85 11 11 0 0 0 6.68 2.31 10 10 0 0 0 1.11-.07v2.53H3.74a.72.72 0 0 0-.59.29.74.74 0 0 0-.13.64l4.12 16.31a.77.77 0 0 0 .73.57H23a.75.75 0 0 0 .72-.57l4.13-16.31a.74.74 0 0 0-.13-.64.76.76 0 0 0-.63-.29m-7.26-10.1a9.38 9.38 0 0 1 6.78-1.94A9.37 9.37 0 0 1 23 8a9.38 9.38 0 0 1-6.78 1.94 9.37 9.37 0 0 1 3.61-6.13M7.8 8a9.37 9.37 0 0 1-3.57-6.13A9.4 9.4 0 0 1 11 3.81a9.34 9.34 0 0 1 3.58 6.08A9.37 9.37 0 0 1 7.8 8m14.58 22.22H8.45L6 20.56h18.83Zm2.83-11.16H5.63l-.92-3.65h21.42Z"
      data-name="smart-send-time"
    />
  </svg>
);

export default SvgLearningStipend;
